import { Component, DestroyRef, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './shared/components/layout/header/header.component';
import { Subscription } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IScreenType, ScreenType, SharedService } from './shared/services/shared.service';

const MOBILE_VIEW = 'screen and (max-width: 768px)';
const TABLET_VIEW = 'screen and (min-width: 769px) and (max-width: 1024px)';
const MONITOR_VIEW = 'screen and (min-width: 1024px)';
const BELOWMONITOR = 'screen and (max-width: 1023px)';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, HeaderComponent],
    standalone:true,
    templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'smslink';
    private layoutChangesSubscription = Subscription.EMPTY;
  
    breakpointObserver =inject(BreakpointObserver);
    sharedService =inject(SharedService);
    destroyRef =inject(DestroyRef);

  constructor(
  ){

        this.layoutChangesSubscription = this.breakpointObserver
    
          .observe([MOBILE_VIEW, MONITOR_VIEW])
          .pipe(takeUntilDestroyed(this.destroyRef))
    
          .subscribe((state) => {
            let obj: IScreenType = {
              desktop: state.breakpoints[MONITOR_VIEW],
              mobile: state.breakpoints[MOBILE_VIEW],
            };
    
            for (const key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) {
                const element = obj[key as keyof IScreenType];
                if (element) {
                  this.sharedService.updateScreenType(key as ScreenType);
                }
              }
            }
          });
    
  }



    ngOnDestroy() {
    this.layoutChangesSubscription.unsubscribe();
  }
}
